/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Eulicer Zapata Orrego                                      ║
║ eulicer.zapata@iudigital.edu.co                            ║
╚════════════════════════════════════════════════════════════╝
*/
import React from "react";
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Icon,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
  TextField,
  styled,
  Button,
  Card,
  FormHelperText,
  Grid,
} from "@mui/material";
import colors from "assets/theme/base/colors";
import closeImg from "assets/images/close_X.svg";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { useTheme } from "@mui/material/styles";
export default function ModalAddInvitadoAndCarnet({
  open,
  handleClose,
  isFormModified,
  isDisabled,
  getFieldValue,
  handleFieldChange,
  handleSubmit,
  isFieldValid,
  bloodTypes,
  cardTypes,
  carnetTypes,
  dataSourseId,
  fieldErrors,
  dataSource,
}) {
  const theme = useTheme();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "700px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
    maxHeight: "90vh", // Aseguramos que el modal sea más grande para pantallas pequeñas
    [theme.breakpoints.down("sm")]: {
      overflowY: "auto", // Solo agregar scroll en pantallas pequeñas
    },
  };

  const photo = getFieldValue("photo");

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card
        sx={{
          ...style,
          display: "flex",
          flexDirection: "column", // Asegura que los elementos se apilen verticalmente
        }}
      >
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "sticky",
            top: -50,
            zIndex: 10,
          }}
        >
          <Typography id="modal-modal-title" component="h2">
            Ingresar usuario y asignar carnet
          </Typography>
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={handleClose}
          >
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />
        <form
          onSubmit={handleSubmit}
          style={{
            flexGrow: 1, // Permite que el formulario ocupe el espacio disponible
            overflowY: "auto", // Habilita el scroll vertical si el contenido es demasiado grande
          }}
        >
          <div style={{ paddingBottom: "16px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Nombres
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  label=""
                  error={!isFieldValid.name}
                  helperText={!isFieldValid.name ? "Ingrese un nombre válido." : ""}
                  FormHelperTextProps={{ className: !isFieldValid.name ? "Mui-error" : "" }}
                  value={getFieldValue("name")}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "");
                    handleFieldChange("name", inputValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Apellidos
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  error={!isFieldValid.lastname}
                  helperText={!isFieldValid.lastname ? "Ingrese un apellido válido." : ""}
                  FormHelperTextProps={{ className: !isFieldValid.lastname ? "Mui-error" : "" }}
                  label=""
                  value={getFieldValue("lastname")}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "");
                    handleFieldChange("lastname", inputValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Documento de Identificación
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  error={!isFieldValid.number_id}
                  helperText={
                    !isFieldValid.number_id ? "Ingrese un número de identificación válido." : ""
                  }
                  FormHelperTextProps={{ className: !isFieldValid.number_id ? "Mui-error" : "" }}
                  label=""
                  value={getFieldValue("number_id")}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/[^0-9]/g, ""); // Permite solo números
                    handleFieldChange("number_id", inputValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Correo electrónico
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  error={!isFieldValid.email}
                  helperText={!isFieldValid.email ? "Ingrese un correo válido." : ""}
                  FormHelperTextProps={{ className: !isFieldValid.email ? "Mui-error" : "" }}
                  label=""
                  value={getFieldValue("email")}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, ""); // Solo permite letras, números, @, ., _ y -
                    handleFieldChange("email", inputValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Fecha de habilitación
                </Typography>
                <MDInput
                  error={!isFieldValid.created}
                  helperText={fieldErrors.created}
                  FormHelperTextProps={{ className: "Mui-error" }}
                  type="datetime-local"
                  fullWidth
                  style={{ marginTop: "5px" }}
                  label=""
                  value={getFieldValue.created}
                  onChange={(e) => handleFieldChange("created", e.target.value)}
                  min={new Date().toISOString().slice(0, 16)} // Bloquea selección de fechas pasadas en el selector
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Fecha de expiración
                </Typography>
                <MDInput
                  error={!isFieldValid.expires_in}
                  helperText={fieldErrors.expires_in}
                  type="datetime-local"
                  FormHelperTextProps={{ className: "Mui-error" }}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  label=""
                  value={getFieldValue("expires_in")}
                  onChange={(e) => handleFieldChange("expires_in", e.target.value)}
                  min={getFieldValue.created || new Date().toISOString().slice(0, 16)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description333" sx={{ mt: 2 }}>
                  Tipo de sangre
                </Typography>
                <FormControl fullWidth sx={{ minWidth: 80 }}>
                  <Select
                    labelId="labelId-select-tipo-de-fuente"
                    id="select-tipo-de-fuente"
                    value={getFieldValue("blood_type") ? getFieldValue("blood_type") : ""}
                    onChange={(e) => handleFieldChange("blood_type", e.target.value)}
                    style={{ fontSize: "15px", padding: "10px" }}
                    disabled={isDisabled}
                    displayEmpty
                  >
                    <MenuItem value={""}>Seleccione...</MenuItem>
                    {bloodTypes
                      ? bloodTypes.map((type) => {
                          return (
                            <MenuItem key={type} value={type}>
                              {type}
                            </MenuItem>
                          );
                        })
                      : []}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Condición especial
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  error={!isFieldValid.special_condition}
                  helperText={
                    !isFieldValid.special_condition ? "Ingrese una condición especial válida." : ""
                  }
                  FormHelperTextProps={{
                    className: !isFieldValid.special_condition ? "Mui-error" : "",
                  }}
                  label=""
                  value={getFieldValue("special_condition")}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "");
                    handleFieldChange("special_condition", inputValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Lugar de origen
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  fullWidth
                  style={{ marginTop: "5px" }}
                  error={!isFieldValid.origin_place}
                  helperText={
                    !isFieldValid.origin_place ? "Ingrese un lugar de origen válido." : ""
                  }
                  FormHelperTextProps={{ className: !isFieldValid.origin_place ? "Mui-error" : "" }}
                  label=""
                  value={getFieldValue("origin_place")}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "");
                    handleFieldChange("origin_place", inputValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Estado
                </Typography>
                <FormControl fullWidth error={!isFieldValid.status}>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={getFieldValue("status")}
                    onChange={(e) => handleFieldChange("status", e.target.value)}
                  >
                    <FormControlLabel
                      disabled={isDisabled}
                      value={"Activo"}
                      control={<Radio />}
                      label="Activo"
                    />
                    <FormControlLabel
                      disabled={isDisabled}
                      value={"Inactivo"}
                      control={<Radio />}
                      label="Inactivo"
                    />
                  </RadioGroup>
                  {!isFieldValid.status && <FormHelperText>Rol requerido</FormHelperText>}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                  Tipo de carnet
                </Typography>
                <FormControl fullWidth sx={{ minWidth: 80 }} error={!isFieldValid.card_type_id}>
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    // Mapear el nombre al ID correspondiente
                    value={getFieldValue("card_type_id") ? getFieldValue("card_type_id") : ""}
                    onChange={(e) => handleFieldChange("card_type_id", e.target.value)}
                    style={{ fontSize: "15px", padding: "10px" }}
                    displayEmpty
                    disabled={true}
                  >
                    <MenuItem value={""}>Seleccione...</MenuItem>
                    {carnetTypes.map((carnet) => (
                      <MenuItem key={carnet.id} value={carnet.name}>
                        {carnet.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {!isFieldValid.card_type_id && (
                    <FormHelperText>Tipo de carnet requerido</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
        <Divider variant="middle" />
        {/* Botones siempre visibles al final */}
        <MDBox
          style={{
            display: "flex",
            justifyContent: "space-around",
            backgroundColor: "white",
            padding: "16px 0",
            flexShrink: 0, // Evita que los botones se muevan
          }}
          m={-0.5}
          mb={-2}
        >
          <MDButton color="error" onClick={handleClose}>
            Cancelar
          </MDButton>
          <MDButton
            onClick={handleSubmit}
            type="submit"
            disabled={
              isDisabled ||
              isFormModified ||
              !!fieldErrors?.expires_in ||
              !!fieldErrors?.created ||
              !getFieldValue("created") ||
              !getFieldValue("expires_in")
            }
            color="success"
          >
            Guardar
          </MDButton>
        </MDBox>
      </Card>
    </Modal>
  );
}

ModalAddInvitadoAndCarnet.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  getFieldValue: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isFormModified: PropTypes.bool,
  isFieldValid: PropTypes.object,
  bloodTypes: PropTypes.array,
  cardTypes: PropTypes.array,
  dataSourceId: PropTypes.string,
  fieldErrors: PropTypes.object,
};
